import { authOptions } from '@/app/api/auth/[...nextauth]/config';
import axios, { AxiosRequestHeaders } from 'axios';
import { getServerSession } from 'next-auth';
import { getSession, signOut } from 'next-auth/react';

const isServerEnvironment = typeof window === 'undefined';

const isWithoutAuth = (headers: AxiosRequestHeaders) => {
  const isWithoutAuth = headers.get('noAuth');
  headers.delete('noAuth');
  return isWithoutAuth;
};

const addAccessTokenToHeaders = (
  headers: AxiosRequestHeaders,
  accessToken?: string
) => {
  if (!accessToken) return;
  headers.set('Authorization', `Bearer ${accessToken}`);
  headers.set('AUTHORIZATIONJWT', `Bearer ${accessToken}`);
};

if (isServerEnvironment) {
  axios.interceptors.request.use(async (config) => {
    if (isWithoutAuth(config.headers)) return config;

    const session = await getServerSession(authOptions());
    addAccessTokenToHeaders(config.headers, session?.user?.accessToken);
    return config;
  });
} else {
  axios.interceptors.request.use(async (config) => {
    if (isWithoutAuth(config.headers)) return config;

    const session = await getSession();
    if (session?.error) await signOut();
    addAccessTokenToHeaders(config.headers, session?.user?.accessToken);

    return config;
  });
}
